import { Grid, Skeleton } from '@mui/material';
import '../../simulation-summary.scss';
import { useAppSelector } from 'src/hooks';
import { IScenarioSummaryStrip2 } from '../../../scenarios/types/scenario.model';

export default function MetricsCardComponent() {
  const { summaryMetrics: summaryData, isFetchingSummaryMetadata } =
    useAppSelector((state) => state.summary);
  const { summary_strip_data } = summaryData;

  // Get an array of child object keys in summary_strip_data
  const childKeys = Object.keys(summary_strip_data).filter(
    (key) => key !== 'internal_dt' && key !== 'external_dt'
  );

  // sorting the object keys by the "order" key
  childKeys.sort(
    (a, b) => summary_strip_data[a].order - summary_strip_data[b].order
  );

  return summaryData &&
    summaryData?.summary_strip_data &&
    Object.keys(summaryData.summary_strip_data).length > 0 ? (
    <Grid
      container
      spacing={2}
      alignItems='center'
      style={{ marginBottom: '10px' }}
    >
      {childKeys.map((metric) => (
        <Grid item xs>
          {isFetchingSummaryMetadata ? (
            <Skeleton variant='rectangular' height='70px' />
          ) : (
            <div
              style={{
                boxShadow: '0px 0px 10px 3px rgba(0, 0, 0, 0.04)',
                background: 'white',
                padding: '15px'
              }}
            >
              <div className='legend-box'>
                <div
                  className='new-icon'
                  style={{
                    background: summary_strip_data[metric].color
                      ? summary_strip_data[metric].color
                      : '#fff',
                    borderRadius: '50%'
                  }}
                >
                  &nbsp;
                </div>
                <span style={{ fontWeight: '700', fontSize: '14px' }}>
                  {summary_strip_data[metric].label}
                </span>
              </div>
              <div style={{ fontWeight: '700', fontSize: '24px' }}>
                <span>{`${
                  summary_strip_data[metric]
                    ? summary_strip_data[metric].value
                    : 0
                } ${summary_strip_data[metric].unit}`}</span>
              </div>
            </div>
          )}
        </Grid>
      ))}
    </Grid>
  ) : null;
}
